import { PlayArrow } from '@mui/icons-material';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';

const DropdownContainer = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    width: 100%;
`;

const disabledStyle = css`
    background-color: #fbd1d9;
    pointer-events: none;
`;

const DropdownSelect = styled.select<{ isDisabled?: boolean }>`
    width: 100%;
    padding: 0.5rem; 
    font-size: 0.8rem;
    border: 2px solid #58585A;
    border-radius: 30px;
    outline: none;
    appearance: none; 
    -webkit-appearance: none; 
    -moz-appearance: none;
    cursor: pointer;
    text-align: center;
    ${({ isDisabled }) => isDisabled && disabledStyle}
`;

const PhaseDropdownSelect = styled(DropdownSelect)`
    padding: 8px 40px 8px 8px;
`;

const RotatingPlayArrow = styled(PlayArrow) <{ $isExpanded: boolean }>`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: ${({ $isExpanded }) => $isExpanded ? 'translateY(-50%) rotate(90deg)' : 'translateY(-50%) rotate(0deg)'};
    transition: transform 0.3s ease !important;
    cursor: pointer;
    z-index: 10;
`;

interface OptionType {
    value: number;
    label: string;
}

interface Props {
    options: OptionType[];
    onChange?: (value: number) => void;
    defaultValue?: number;
    variant?: "phase";
    disabled?: boolean;
}

const CustomDropdown: React.FC<Props> = ({ options, onChange, defaultValue, variant, disabled }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if (onChange) {
            onChange(parseInt(e.target.value));
        }
    };

    const toggleDropdown = () => {
        if (!disabled) {
            setIsDropdownOpen(!isDropdownOpen);
        }
    };

    return (
        <>
            {!variant &&
                <DropdownContainer>
                    <DropdownSelect onClick={toggleDropdown} onChange={handleDropdownChange} defaultValue={defaultValue} isDisabled={disabled}>
                        {options.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </DropdownSelect>
                    <RotatingPlayArrow fontSize='medium' $isExpanded={isDropdownOpen} onClick={toggleDropdown} />
                </DropdownContainer>
            }
            {variant === "phase" &&
                <DropdownContainer>
                    <PhaseDropdownSelect onClick={toggleDropdown} onChange={handleDropdownChange} defaultValue={defaultValue} isDisabled={disabled}>
                        {options.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </PhaseDropdownSelect>
                    <RotatingPlayArrow fontSize='medium' $isExpanded={isDropdownOpen} onClick={toggleDropdown} />
                </DropdownContainer>
            }
        </>
    );
};

export default CustomDropdown;
